import {defineMessages} from 'react-intl'

/**
 * Segment labels shared by the KPI cards, the trend chart series and the
 * waterfall categories. The segments themselves are business enums that travel
 * to the API in English (`commissionPaymentStatus`); only the label is
 * translated — see CLAUDE.md "Executive Dashboard — Segmentation Logic" and
 * §10 of docs/i18n-project-plan.md.
 */
export const EXECUTIVE_SERIES = defineMessages({
  newEnrollments: {
    id: 'dashboard.executive.series.newEnrollments',
    defaultMessage: 'New Enrollments',
  },
  cancellations: {id: 'dashboard.executive.series.cancellations', defaultMessage: 'Cancellations'},
  cancelled: {id: 'dashboard.executive.series.cancelled', defaultMessage: 'Cancelled'},
  neverStarted: {id: 'dashboard.executive.series.neverStarted', defaultMessage: 'Never Started'},
  noCommission: {id: 'dashboard.executive.series.noCommission', defaultMessage: 'No Commission'},
  standBy: {id: 'dashboard.executive.series.standBy', defaultMessage: 'Stand By'},
  netGrowth: {id: 'dashboard.executive.series.netGrowth', defaultMessage: 'Net Growth'},
  activePolicies: {
    id: 'dashboard.executive.series.activePolicies',
    defaultMessage: 'Active Policies',
  },
})

/** Column headers reused by the breakdown table and the per-period table. */
export const EXECUTIVE_COLUMNS = defineMessages({
  period: {id: 'dashboard.executive.col.period', defaultMessage: 'Period'},
  new: {id: 'dashboard.executive.col.new', defaultMessage: 'New'},
  vsPrev: {id: 'dashboard.executive.col.vsPrev', defaultMessage: 'vs Prev'},
  share: {id: 'dashboard.executive.col.share', defaultMessage: 'Share'},
  cancels: {id: 'dashboard.executive.col.cancels', defaultMessage: 'Cancels'},
  active: {id: 'dashboard.executive.col.active', defaultMessage: 'Active'},
  cohort3m: {id: 'dashboard.executive.col.cohort3m', defaultMessage: 'Cohort 3m'},
  cohort6m: {id: 'dashboard.executive.col.cohort6m', defaultMessage: 'Cohort 6m'},
  renewalsPct: {id: 'dashboard.executive.col.renewalsPct', defaultMessage: 'Renewals%'},
  cancelsPct: {id: 'dashboard.executive.col.cancelsPct', defaultMessage: 'Cancels%'},
  churn: {id: 'dashboard.executive.col.churn', defaultMessage: 'Churn'},
})

/** Punctuation and symbols that must never reach the catalog (guía §17.3). */
export const EM_DASH = '—'
export const ARROW_UP = '↑'
export const ARROW_DOWN = '↓'
export const ZERO_DELTA = '= 0'
export const ELLIPSIS = '…'
export const WARNING_SIGN = '⚠'
export const CLEAR_ICON = '✕'
